module.exports = __webpack_public_path__ + "components/rewards/snowtrex/static/snowtrex-5704b6c9d54704963af1801d049cb5da.png";